import { render, staticRenderFns } from "./Supervision.vue?vue&type=template&id=6b0c2f7e&"
import script from "./Supervision.vue?vue&type=script&lang=js&"
export * from "./Supervision.vue?vue&type=script&lang=js&"
import style0 from "./Supervision.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports